import { InnerBlocks } from '@wordpress/block-editor';

/**
 * The wrapper and its stagger classes are built by render.php, so the saved
 * markup is the notes and nothing else. Keeping the arrangement on the server
 * means changing how the stagger works later does not invalidate every row
 * already published.
 */
export default function Save() {
  return <InnerBlocks.Content />;
}
